/**
 * Human-readable screen titles matching legacy/mobile naming.
 * URL path segments are derived from internal ids (`screen.inAnEmergency` → `in-an-emergency`)
 * via `screenIdToUrlSlug` — not from these strings — so titles can contain spaces.
 */

export const IN_AN_EMERGENCY_SCREEN = "In an Emergency"
export const OPERATOR_OVERVIEW_SCREEN = "Operator Overview"
export const COMPANY_OVERVIEW_SCREEN = "Company Overview"
/** Mobile `COMMUNICATIONS_SCREEN` — asset Emergency Response communications page title. */
export const RADIO_COMMUNICATIONS_SCREEN = "Radio Communications"
